export default {
  conversation_dnd_message: '{name} está en NM',
  conversation_dnd_message_with_time:
    '{name} está en NM hasta las {time, time, short}',
  conversation_dnd_message_tooltip_content: '{name} no recibirá notificaciones',
};
